import dynamic from "next/dynamic";

export const SectorRoles = dynamic(() => import("./component"));
